/** Opt-in responsive attribution for one link shared across Tailwind's md
 *  breakpoint. Resolve when the event occurs so viewport changes stay accurate. */
export const resolveTrackingPosition = (el: HTMLElement): string | undefined => {
  const desktopPosition = el.dataset.trackPositionDesktop
  if (desktopPosition && window.matchMedia('(min-width: 768px)').matches) {
    return desktopPosition
  }
  return el.dataset.eventPosition
}
